import React from 'react'
import utils from '../utils';
import { Helmet } from 'react-helmet';

function RefundPage() {
    const url = typeof window !== 'undefined' ? window.location.href : '';

    return (
        <div>
            <Helmet>
                <title>Refund Policy - {utils.siteName}</title>
                <link rel="canonical" href={url} />
            </Helmet>
            <div>
                <header className="hero-bg text-white py-16">
                    <div className="container mx-auto px-4 text-center">
                        <h1 className="text-4xl md:text-6xl font-black">Refund Policy</h1>
                        <p className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto">Your satisfaction is our priority. Please review our refund policy below.</p>
                        <div className="mt-6 mx-auto w-20 h-1.5 bg-secondary rounded-full"></div>
                    </div>
                </header>
                <section className="py-16 lg:py-24">
                    <div className="container mx-auto px-4">
                        <div className="max-w-4xl mx-auto bg-white dark:bg-slate-900 p-8 md:p-12 rounded-lg shadow-xl">
                            <div className="prose prose-lg dark:prose-invert max-w-none text-gray-700 dark:text-gray-300">
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 uppercase">Overview</h2>
                                <p>
                                    This Returns & Refunds Policy explains how returns, exchanges, and refunds are handled on the Koova platform.
                                </p>
                                <p>
                                    By placing an order on Koova, you agree to this Policy in addition to the Koova Terms & Conditions.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">
                                    1. Platform Role
                                </h2>
                                <p>
                                    Koova operates as an online marketplace connecting buyers and independent sellers.
                                </p>
                                <p>
                                    Unless expressly stated otherwise:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Sellers are responsible for fulfilling orders, handling returns, and issuing refunds
                                    </li>
                                    <li>
                                        Koova is not the seller of listed items and does not take ownership of products
                                    </li>
                                </ul>
                                <p>
                                    Koova may, at its discretion, assist with dispute resolution but is not obligated to provide refunds on behalf of sellers.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">2. Eligibility for a Refund</h2>
                                <p>
                                    A product may be eligible for return if:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        It is defective, damaged, or not as described
                                    </li>
                                    <li>
                                        It is incomplete or missing essential components
                                    </li>
                                    <li>
                                        It was delivered in error (wrong item or quantity)
                                    </li>
                                </ul>
                                <p>
                                    Returns must be requested <strong>within [7 / 14] days</strong> of delivery, unless a different return window is stated by the seller.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">3. Non-Returnable Items</h2>
                                <p>
                                    The following items are not eligible for return or refund unless required by law:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Perishable goods
                                    </li>
                                    <li>
                                        Personalized or custom-made items
                                    </li>
                                    <li>
                                        Digital products or downloadable content
                                    </li>
                                    <li>
                                        Intimate, sanitary, or hygiene-related items once opened
                                    </li>
                                    <li>
                                        Items marked as “Final Sale” or “Non-Returnable”
                                    </li>
                                    <li>
                                        Services that have already been rendered
                                    </li>
                                </ul>
                                <p>
                                    Sellers may specify additional non-returnable categories, provided they comply with applicable law.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10">4. CONDITION OF RETURNED ITEMS</h2>
                                <p>
                                    To be eligible for a return, items must:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Be unused, unworn, and unaltered (unless defective)
                                    </li>
                                    <li>
                                        Be returned in original packaging with all accessories and documentation
                                    </li>
                                    <li>
                                        Not show signs of misuse, damage, or tampering
                                    </li>
                                </ul>
                                <p>
                                    Sellers may reject returns that do not meet these conditions.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">5. HOW TO REQUEST A RETURN</h2>
                                <p>
                                    To initiate a return:
                                </p>

                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Log in to your Koova account
                                    </li>
                                    <li>
                                        Navigate to your order history
                                    </li>
                                    <li>
                                        Submit a return request with a clear reason and supporting evidence (e.g. photos)
                                    </li>
                                </ul>
                                <p>
                                    Koova or the seller will review the request and respond within a reasonable timeframe.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">6. RETURN SHIPPING</h2>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Buyers may be responsible for return shipping costs unless the item is defective, damaged, or incorrectly delivered
                                    </li>
                                    <li>
                                        Return shipping methods and instructions will be provided upon approval
                                    </li>
                                    <li>
                                        Koova is not responsible for items lost or damaged during return transit
                                    </li>
                                </ul>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">7. REFUNDS</h2>
                                <p>
                                    Once a returned item is received and inspected:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Refunds will be processed using the original payment method or Koova store credit
                                    </li>
                                    <li>
                                        Processing times may vary depending on the payment provider
                                    </li>
                                    <li>
                                        Shipping fees are non-refundable unless required by law
                                    </li>
                                </ul>
                                <p>
                                    If Koova store credit is issued, it will be governed by the <span className="text-secondary hover:underline">Koova Store Credit Terms</span>.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">8. EXCHANGES</h2>
                                <p>
                                    Exchanges are subject to seller availability and approval. If an exchange is not possible, a refund may be issued in accordance with this Policy.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">9. SELLER-SPECIFIC RETURN TERMS</h2>
                                <p>
                                    Some sellers may offer return terms that differ from this Policy. Where disclosed clearly on the product listing, those terms will apply, provided they comply with applicable law.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">10. DISPUTES AND ESCALATION</h2>
                                <p>
                                    If a buyer and seller are unable to resolve a return issue:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Koova may review the matter and decide based on available evidence
                                    </li>
                                    <li>
                                        Koova’s decision, where provided, is final and binding for platform purposes
                                    </li>
                                </ul>
                                <p>
                                    Koova reserves the right to suspend or restrict accounts that abuse the returns process.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">11. ABUSE AND FRAUD PREVENTION</h2>
                                <p>
                                    Koova may deny returns or refunds where there is evidence of:
                                </p>
                                <ul className="list-disc pl-5 space-y-2">
                                    <li>
                                        Repeated or excessive returns
                                    </li>
                                    <li>
                                        Fraudulent activity or misrepresentation
                                    </li>
                                    <li>
                                        Policy abuse
                                    </li>
                                </ul>
                                <p>
                                    Such activity may result in account suspension or termination.
                                </p>
                                <h2 className="text-2xl font-bold text-gray-900 dark:text-white border-b-2 border-secondary pb-2 mt-10 uppercase">12. CHANGES TO THIS POLICYS</h2>
                                <p>
                                    Koova may update this Returns & Refunds Policy from time to time. Changes will be effective upon publication.
                                </p>
                                 <p>
                                    Your continued use of the Platform constitutes acceptance of the updated Policy.
                                </p>
                                {/* <div className="mt-12 p-6 rounded-lg bg-red-50 dark:bg-red-950/50 border border-primary">
                                    <h3 className="text-xl font-semibold text-primary dark:text-orange-300">Late or Missing Refunds</h3>
                                    <p className="mt-2">If you haven’t received a refund yet, first check your bank account again. Then contact your credit card company, it may take some time before your refund is officially posted. If you’ve done all of this and you still have not received your refund yet, please contact us at <a className="text-secondary font-semibold hover:underline" href="mailto:support@gadzone.co.ke">support@gadzone.co.ke</a>.</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}

export default RefundPage